// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("assets/css/" + chunkId + "." + "59a55201" + ".css");